<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          COST CENTER
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Cost Center List
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
          <v-flex xs4 class="my-5">
            <v-text-field
              id="search"
              v-model="search"
              append-icon="search"
              placeholder="Search"
              single-line
              hide-details
              @keyup="searchData()"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs8
            class="text-right"
            v-if="hasPermission('create_master_data', 'create')"
          >
            <v-btn
              id="add-costCenter"
              :to="{ name: 'costCenterCreate' }"
              depressed
              color="secondblue"
              class="white--text"
            >
              <v-icon left dark>add</v-icon>
              Add new cost Center
            </v-btn>
          </v-flex>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          :must-sort="true"
          :options.sync="options"
          :server-items-length="totalItems"
          :sort-desc.sync="descending"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 25]
          }"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          ></v-progress-linear>
          <template v-slot:item.type="{ item }">
            <span class="text-capitalize">{{ item.type || '-' }}</span>
          </template>
          <template v-slot:item.description="{ item }">{{
            strLimit(item.desc, 70) || '-'
          }}</template>
          <template v-slot:item.created_by="{ item }">
            {{
              item.logCreate
                ? item.logCreate.length > 0
                  ? item.logCreate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.updated_by="{ item }">
            {{
              item.logUpdate
                ? item.logUpdate.length > 0
                  ? item.logUpdate[0].user.email
                  : '-'
                : '-'
            }}
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              :id="'btn-detail' + item.id"
              icon
              @click="detail(item.id)"
              v-if="hasPermission('view_master_data', 'view')"
            >
              <v-icon color="green">remove_red_eye</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-edit' + item.id"
              @click="edit(item.id)"
              icon
              v-if="hasPermission('update_master_data', 'update')"
            >
              <v-icon color="secondblue">mdi-square-edit-outline</v-icon>
            </v-btn>
            <v-btn
              :id="'btn-delete' + item.id"
              @click="deleteItem(item.id)"
              icon
              v-if="hasPermission('delete_master_data', 'delete')"
            >
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <label>No data displayed</label>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import paginationMixin from '../../../mixins/paginationMixin';

export default {
  components: { 'progress-dialog': ProgressDialog },
  mixins: [ACLMixin, paginationMixin],
  data() {
    return {
      loading: true,
      progressDialogLoading: true,
      search: '',
      isSearch: false,
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 5
      },
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Cost Center List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 5,
      headers: [
        {
          text: 'Code',
          value: 'code'
        },
        {
          text: 'Description',
          value: 'desc'
        },
        {
          text: 'Working / Non Working',
          value: 'type'
        },
        {
          text: 'Created At',
          value: 'created_at'
        },
        {
          text: 'Created By',
          value: 'created_by'
        },
        {
          text: 'Updated At',
          value: 'updated_at'
        },
        {
          text: 'Updated By',
          value: 'updated_by'
        },
        {
          text: 'Action',
          value: 'action',
          align: 'center',
          sortable: false
        }
      ],
      items: [],
      timeout: null
    };
  },
  watch: {
    descending(value) {
      console.log(value);
      this.getData();
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    searchData() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData();
      }, 900);
    },
    getData() {
      this.progressDialogLoading = true;
      this.loading = true;
      const search = {
        code: this.search,
        desc: this.search
      };
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      if (this.descending) {
        this.sort = 'desc';
      } else {
        this.sort = 'asc';
      }
      const sort = this.sort;
      this.$store
        .dispatch('costCenter/getAll', {
          page,
          limit: itemsPerPage,
          sort,
          search
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.result;
            this.totalItems = data.data.total_data;
            page = data.data.pagination.current_page;
            itemsPerPage = data.data.pagination.per_page;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    deleteItem(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this cost center!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it'
      }).then(result => {
        if (result.value) {
          this.progressDialogLoading = true;
          this.loading = true;
          this.$store.dispatch('costCenter/delete', id).then(data => {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Deleted!', data.message.text_en, 'success');
            this.getData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your cost center data has been undeleted',
            'error'
          );
        }
      });
    },
    edit(id) {
      this.$router.push({
        name: 'costCenterEdit',
        params: { id: id }
      });
    },
    detail(id) {
      this.$router.push({
        name: 'costCenterDetail',
        params: { id: id }
      });
    }
  }
};
</script>
